import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Разобранный отказ ручки покупки. */
export interface BuyFailure {
  status?: number
  code: string
  message: string
}

interface Detail {
  code?: string
  message?: string
}

/**
 * Свой разбор ровно этой ручки — как `translationPublishFailureText` у
 * публикации языка. `parseStartError` описывает отказы ЧЕТЫРЁХ стартов
 * прогонов, коды покупки в его таблице отсутствуют.
 */
export const parseBuyError = (error: unknown): BuyFailure => {
  const e = error as { status?: number; data?: { detail?: unknown } } | undefined
  const raw = e?.data?.detail
  const detail: Detail =
    raw && typeof raw === 'object' && !Array.isArray(raw) ? (raw as Detail) : {}
  return {
    status: e?.status,
    code: detail.code ?? '',
    message: detail.message || messagesNow(messages).buyFailed,
  }
}

export interface BuyFailureView {
  title: string
  /** `reload` — витрина устарела, перечитать её; `back` — выбрать иначе. */
  action: 'back' | 'reload'
}

export const buyFailureText = (failure: BuyFailure): BuyFailureView => {
  if (failure.code === 'ai_credit_package_not_found')
    return { title: messagesNow(messages).packageGone, action: 'reload' }
  if (failure.code === 'email_required_for_tbank')
    // Кнопки «указать email» нет намеренно: экрана правки профиля в студии не
    // существует («Аккаунт — скоро»), и она вела бы в никуда.
    return {
      title: messagesNow(messages).emailRequired,
      action: 'back',
    }
  return { title: failure.message, action: 'back' }
}
